import { Box } from '@mui/material';

export default function Territories() {
	return <Box>Territories</Box>;
}
